import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect } from "react";
import { getTemplateVariablesRequest } from "src/pages/ExportPage/store/fetchers";

// Тонкая обёртка над reatomAsync-fetcher'ом: триггерит первую загрузку и
// возвращает текущее состояние из атомов. Кэш живёт в атоме до перезагрузки
// страницы — повторные маунты формы не вызывают сеть.
export const useTemplateVariables = () => {
  const [data] = useAtom(getTemplateVariablesRequest.dataAtom);
  const [isLoading] = useAtom(getTemplateVariablesRequest.isLoadingAtom);
  const [error] = useAtom(getTemplateVariablesRequest.errorAtom);
  const fetchVariables = useAction(getTemplateVariablesRequest);

  useEffect(() => {
    if (!data) fetchVariables();
  }, [data, fetchVariables]);

  return {
    data,
    isLoading,
    error: error instanceof Error ? error : null,
  };
};
